import React from 'react'
import PropTypes, { array } from 'prop-types'
import ServiceRow from './ServiceRow'
import { mapServiceTypeToTitle, NETWORK_TELSTRA } from '../constants'
import UsageRow from './UsageRow'

const ServiceRowMobile = (props) => {
    return (
        <ServiceRow
            icon={`/images/icon-${props.item.type}.svg`}
            title={mapServiceTypeToTitle[props.item.type]}
            subTitle={props.item.description}
            preTitle={props.item.serviceNumber}
            url={`/my-services/${props.item.type}/${props.item.id}`}
        >
            <React.Fragment>
                <UsageRow
                    title='Allowances reset'
                    isUnlimitedUsage={false}
                    progress={props.item.billingCycleProgressPercentage}
                    summaryText={props.item.nextBillingCycleStart}
                    isDateField
                />

                {Object.keys(props.item.usageSummary).map(key => {
                    const item = props.item.usageSummary[key]

                    if (key !== 'data_addon' && (key !== 'others_and_excluded' || (key === 'others_and_excluded' && item.summaryUsed > 0))) {
                        return (
                            <UsageRow
                                key={key}
                                itemKey={key}
                                title={item.labelText}
                                isUnlimitedUsage={key === 'others_and_excluded' ? true : item.isUnlimitedUsage}
                                progress={item.usagePercentage}
                                summaryText={item.summaryText}
                                isDataBank={key === 'data_bank'}
                            />
                        )
                    } else if (key === 'data_addon') {
                        return item.map((innerItem, innerKey) => {
                            return (
                                <UsageRow
                                    key={innerKey}
                                    itemKey={key}
                                    title='Data Add-on'
                                    isUnlimitedUsage={innerItem.isUnlimitedUsage}
                                    progress={innerItem.usagePercentage}
                                    summaryText={innerItem.summaryText}
                                />
                            )
                        })
                    }
                })}

                {props.item.networkProvider === NETWORK_TELSTRA
                    ? <UsageRow
                            title='Auto-recharge'
                            isUnlimitedUsage
                            summaryText='Every 30 days'
                            showUnlimitedUsage
                      />
                    : ''}
            </React.Fragment>
        </ServiceRow>
    )
}

ServiceRowMobile.propTypes = {
    item: PropTypes.shape({
        type: PropTypes.string,
        description: PropTypes.string,
        serviceNumber: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        usageSummary: PropTypes.object
    }).isRequired
}

export default ServiceRowMobile



// WEBPACK FOOTER //
// ./resources/js/components/ServiceRowMobile.js